import React from 'react';
import Divider from 'components/Divider';
import AutocompleteReact from 'react-autocomplete';
import Autocomplete from 'react-toolbox/lib/autocomplete';
import Button from 'react-toolbox/lib/button';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { RadioGroup, RadioButton } from 'react-toolbox/lib/radio';
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { actSuggestions } from 'constants/DropdownsValues';
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import { is, Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import styles from './AcademicBoard.scss';// to import local scss fle

const gpaSuggestions = {};
const satSuggestions = {};
const emptyObject = {};

class AcademicBoard extends React.Component {


  static propTypes = {
    save: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    back: PropTypes.func.isRequired,
    profile: PropTypes.instanceOf(Map),
    schools: PropTypes.shape(),
    searchSchools: PropTypes.func,
  };
  static defaultProps = {
    save: () => {},
    show: false,
    profile: Map(),
    schools: { school: 'enter school name' },
    searchSchools: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      school: '',
      year_of_graduation: '',
      gpa: '',
      sat: '',
      act: '',
      hbcu: 'no',
      schoolNames: [],
      loader: false,
      satSuggestions: {},
      schoolErrorMessage: '',
      gpaErrorMessage: '',
      satErrorMessage: '',
      actErrorMessage: '',
      yearOfPassingErrorMessage: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.schoolSearch = this.schoolSearch.bind(this);
    this.saveAndLoad = this.saveAndLoad.bind(this);
    this.handleQueryChange = this.handleQueryChange.bind(this);
    this.removeErrorMessage = this.removeErrorMessage.bind(this);
    this.timer = null;
    this.Map = Map;
    this.is = is;
  }

  componentWillReceiveProps(nextProps) {
    const { profile = Map(), schools = {} } = this.props;
    if (nextProps.profile.size > 0 && !is(profile, nextProps.profile)) {
      const academic = nextProps.profile.get('academic');
      const newState = {
        school: nextProps.profile.get('school'),
        year_of_graduation: academic.get('year_of_graduation'),
        gpa: academic.get('gpa'),
        sat: academic.get('sat'),
        act: academic.get('act'),
      };
      this.setState(newState);
    } else if (this.Map.isMap(nextProps.schools) && !this.is(nextProps.schools, schools) && nextProps.schools.get('hits')) {
      const hits = nextProps.schools.get('hits');
      const total = hits.get('total');
      const tempHits = [];
      if (total > 0) {
        let results = nextProps.schools.get('hits');
        results = results.get('hits');
        results = results.toJS();

        results.forEach((school) => {
          const obj = {};
          const college = school._source.school; // eslint-disable-line
          const key = college;
          obj.key = key;
          obj.value = college;
          tempHits.push(obj);
        });
        this.setState({ schoolNames: tempHits });
      }
    }
  }

  schoolSearch(name, value) {
    const query = {};
    if (this.timer) { clearTimeout(this.timer); }

    this.setState({ ...this.state, [name]: value });

    if (value && value.length >= 3) {
      this.timer = setTimeout(() => {
        const obj = {};
        obj.key = 'school';
        obj.value = value;
        query.push(obj);
        this.props.searchSchools(query);
      }, 100);
    }
  }

  handleChange = (name, value) => {
    this.setState({ ...this.state, [name]: value });
  };
  handleQueryChange(name) {
    this.setState({ ...this.state, [name]: '' });
  }
  removeErrorMessage = (name) => {
    this.setState({ ...this.state, [name]: '' });
  };
  saveAndLoad(data) {
    /* school validation */
    let validSchool = false;
    const enteredScool = typeof this.state.school;
    if (enteredScool === 'string' && this.state.school !== '') {
      validSchool = true;
    } else {
      this.setState({ schoolErrorMessage: 'Please select a school.' });
    }
    /* school validation */

    /* year of passing */
    let validYearOfPassing = false;

    if (this.state.year_of_graduation !== '' && !isNaN(this.state.year_of_graduation)) {
      validYearOfPassing = true;
    } else {
      this.setState({ yearOfPassingErrorMessage: 'Please add a valid graduation year.' });
    }
    /* year of passing */

    /* Gpa validation */
    let validGpa = false;
    if (this.state.gpa !== '' && !isNaN(this.state.gpa) && this.state.gpa >= 2 && this.state.gpa <= 4.0) {
      validGpa = true;
    } else {
      this.setState({ gpaErrorMessage: 'Please select a Gpa from list.' });
    }
    /* Gpa validation */

     /* Act validation */
    let validAct = false;
    if (this.state.act >= 16 && this.state.act <= 36) {
      validAct = true;
    } else if (this.state.act === '') {
      validAct = true;
    } else {
      this.setState({ actErrorMessage: 'Enter Act between 16 - 36.' });
    }

    /* Act validation */

     /* Sat validation */
    let validSat = false;
    if (this.state.sat >= 600 && this.state.sat <= 1600) {
      validSat = true;
    } else if (this.state.sat === '') {
      validSat = true;
    } else {
      this.setState({ satErrorMessage: 'Enter Sat between 600 - 1600.' });
    }
     /* Sat validation */

    if (validSchool && validGpa && validYearOfPassing && validAct && validSat) {
      this.setState({ loader: true });
      this.props.save(data);
    }
  }

  render() {
    for(let i = 6;i<16;i++){ //eslint-disable-line
        for(let x = 1;x<=10;x++) { //eslint-disable-line
          let listItem = '';
          let left = '';
          let right = '';
          listItem = ((i * 100) + (x * 10));
          left = listItem;
          right = listItem;
          if (listItem === 600) { left = '600'; right = '600 or Lower'; }
          satSuggestions[`${left}`] = `${right}`;
        }
    }
    // for (let i = 16; i <= 36; i++) { //eslint-disable-line
    //   let listItem = '';
    //   if (i === 16) {
    //     listItem = `${`${i} or Lower`}`;
    //   } else {
    //     listItem = `${i}`;
    //   }
    //
    //   actSuggestions[`${listItem}`] = `${listItem}`;
    // }
    for(let i = 2;i<4;i++){ //eslint-disable-line
          for(let x = 0;x<=10;x++) { //eslint-disable-line
            let listItem = '';
            let left = '';
            let right = '';
              listItem = `${i + "." + x}`; // eslint-disable-line
            if (x === 10) {
                  listItem = `${i+1}.0`; // eslint-disable-line
            }
            left = listItem;
            right = listItem;
            if (listItem === '2.0') { left = '2.0'; right = '2.0 or higher'; } else if (listItem === '4.0') { left = '4.0'; right = '4.0 or Higher'; }
            gpaSuggestions[`${left}`] = `${right}`;
          }
    }
    const renderIfShow = renderIf(this.props.show);
    const renderLoader = renderIf(this.state.loader);
    const { schoolErrorMessage, satErrorMessage, gpaErrorMessage,
            actErrorMessage, yearOfPassingErrorMessage } = this.state;
    return (
      <div>
        {renderLoader(
          <FullScreenLoader />,
          )}
        {renderIfShow(<div className={cn('row', styles.academicContainer)}>
          <div className={cn('col s12', styles.fullWidth)}>
            <div className={schoolErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithAutoComplete) : cn('col s12 m6', styles.halfWidthWithAutoCompleteError)}>
              <span className={styles.spanBlock}>HIGH SCHOOL</span>
              {/* <Example {...this.props} /> */}
              <div className={styles.autoCompleteContainer}>
                <AutocompleteReact
                  inputProps={{ name: 'School', id: 'schools-autocomplete' }}
                  ref="schools-autocomplete" // eslint-disable-line
                  value={this.state.school}
                  items={this.state.schoolNames}
                  getItemValue={item => item.value}
                  onFocus={() => this.removeErrorMessage('schoolErrorMessage')}
                  onSelect={(school, item) => {
                      // set the menu to only the selected item
                    this.setState({ school: item.value });
                      // or you could reset it to a default list again
                      // this.setState({ unitedStates: getStates() })
                  }}
                  onChange={(event, value) => {
                    if (this.timer) { clearTimeout(this.timer); }

                    this.setState({ ...this.state, school: value, schoolErrorMessage: '' });

                    if (value && value.length >= 3) {
                      this.timer = setTimeout(() => {
                        this.props.searchSchools(value);
                      }, 100);
                    }
                  }}
                  renderItem={item => (
                    <div
                      key={item.key}
                      id={item.key}
                    >{item.value}</div>
                  )}
                />
                <Error message={schoolErrorMessage} />
              </div>
            </div>
            <div className={yearOfPassingErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
              <span>GRADUATION YEAR</span>
              <Input
                onChange={val => this.handleChange('year_of_graduation', val)}
                value={this.state.year_of_graduation}
                onFocus={() => this.removeErrorMessage('yearOfPassingErrorMessage')}
              />
              <Error message={yearOfPassingErrorMessage} />
            </div>
            <Divider />
          </div>
          <div className={cn('col s12', styles.fullWidth)}>
            <div className={gpaErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
              <span>GPA</span>
              <Autocomplete
                source={this.state.gpa === '' ? emptyObject : gpaSuggestions}
                selectedPosition="below"
                direction="down"
                value={this.state.gpa}
                allowCreate
                multiple={false}
                onChange={val => this.handleChange('gpa', val)}
                onQueryChange={val => this.handleChange('gpa', val)}
                onFocus={() => this.removeErrorMessage('gpaErrorMessage')}
              />
              <Error message={gpaErrorMessage} />
            </div>
            <div className={satErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
              <span>SAT
              <span className={styles.optionalTag}>&nbsp;&nbsp;(Optional)</span>
              </span>
              <Autocomplete
                source={this.state.sat === '' ? emptyObject : satSuggestions}
                selectedPosition="below"
                direction="down"
                value={this.state.sat}
                multiple={false}
                onChange={val => this.handleChange('sat', val)}
                onQueryChange={val => this.handleChange('sat', val)}
                onFocus={() => this.removeErrorMessage('satErrorMessage')}
              />
              <Error message={satErrorMessage} />
            </div>
            <div className={actErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
              <span>ACT
                <span className={styles.optionalTag}>&nbsp;&nbsp;(Optional)</span>
              </span>
              <Autocomplete
                source={this.state.act === '' ? emptyObject : actSuggestions}
                selectedPosition="below"
                direction="down"
                value={this.state.act}
                multiple={false}
                onChange={val => this.handleChange('act', val)}
                onQueryChange={val => this.handleChange('act', val)}
                onFocus={() => this.removeErrorMessage('actErrorMessage')}
              />
              <Error message={actErrorMessage} />
            </div>
            <div className={cn('col s12 m6', styles.halfWidthRadio)}>
              <p>ARE YOU INTERESTED IN ATTENDING HBCUs?
                (Historically Black Colleges/Universities)
              </p>
              <div className={cn('col s4', styles.removePadding)}>
                <RadioGroup name="hbcu" value={this.state.hbcu} onChange={val => this.handleChange('hbcu', val)}>
                  <RadioButton label="Yes" value="yes" />
                </RadioGroup>
              </div>
              <div className={cn('col s4', styles.radioContainer)} >
                <RadioGroup name="hbcu" value={this.state.hbcu} onChange={val => this.handleChange('hbcu', val)} >
                  <RadioButton label="No" value="no" />
                </RadioGroup>
              </div>
            </div>
          </div>

          <div className={cn('col s12', styles.buttonContainer)}>
            <Button label="< PREVIOUS" className={styles.back} onClick={this.props.back} />
            <Button label="CONTINUE" raised className={styles.continue} onClick={() => this.saveAndLoad(this.state)} />
          </div>
        </div>)}
      </div>
    );
  }
}

export default AcademicBoard;




// WEBPACK FOOTER //
// ./src/components/AcademicBoard/AcademicBoard.js